import React from "react";
import { FaTools } from "react-icons/fa";
import styles from "../../styles/pages/static/MaintenancePage.module.css";

const MaintenancePage = () => {
  return (
    <div className="pageContainer">
      <div className={styles.maintenancePage}>
        <div className={styles.content}>
          <div className={styles.icon}>
            <FaTools />
          </div>
          <h1 className={styles.title}>We will be back soon</h1>
          <p className={styles.subtitle}>
            Simpary is temporarily in maintenance mode while we make improvements.
          </p>
          <p className={styles.note}>
            Thank you for your patience while we perform maintenance. We'll be back online as soon as possible!
          </p>
        </div>
      </div>
    </div>
  );
};

export default MaintenancePage;
